import React, { useEffect, useRef, useState } from "react";
import { ArtifactType, ContentState, ContentSubstate, SKArtifactPayload, Tier } from "../../../models/SKArtifact";
import { useNavigate } from "react-router-dom";
import { createArtifact } from "../../../api/artifacts/atrifactService";
import { capitalizeFirstLetter, isStringEmpty } from "../../../utils/stringFunctions";
import * as Yup from "yup";
import { useAuth } from "../../../context/AuthContext";
interface PopoverProps {
  isOpen: boolean;
  onClose: () => void;
}

const types = [
  {
    imgSrc: "/icons/Text.png",
    type: ArtifactType.text,
    name: ArtifactType.text,
    redirectURL: "../createTextContent",
  },
  {
    imgSrc: "/icons/Photo.png",
    type: ArtifactType.photo,
    name: ArtifactType.photo,
    redirectURL: "",
  },
  {
    imgSrc: "/icons/Video.png",
    type: ArtifactType.video,
    name: ArtifactType.video,
    redirectURL: "",
  },
  {
    imgSrc: "/icons/Audio.png",
    type: ArtifactType.audio,
    name: ArtifactType.audio,
    redirectURL: "",
  },
  {
    imgSrc: "/icons/Link.png",
    type: ArtifactType.link,
    name: ArtifactType.link,
    redirectURL: "",
  },
  {
    imgSrc: "/icons/Story.png",
    type: ArtifactType.story,
    name: ArtifactType.story,
    redirectURL: "",
  },
  {
    imgSrc: "/icons/List.png",
    type: ArtifactType.list,
    name: ArtifactType.list,
    redirectURL: "",
  },
  {
    imgSrc: "/icons/Guide.png",
    type: ArtifactType.guide,
    name: ArtifactType.guide,
    redirectURL: "",
  },
  {
    imgSrc: "/icons/Journal.png",
    type: ArtifactType.journal,
    name: ArtifactType.journal,
    redirectURL: "",
  },
  {
    imgSrc: "/icons/Letter.png",
    type: ArtifactType.letter,
    name: ArtifactType.letter,
    redirectURL: "../createLetter",
  },
  {
    imgSrc: "/icons/Poll.png",
    type: ArtifactType.poll,
    name: ArtifactType.poll,
    redirectURL: "../createPoll",
  },
  {
    imgSrc: "/icons/Greeting.png",
    type: ArtifactType.greeting,
    name: "Greeting Card",
    redirectURL: "../createGreeting",
  },
  {
    imgSrc: "/icons/Place.png",
    type: ArtifactType.place,
    name: ArtifactType.place,
    redirectURL: "../createPlace",
  },
  {
    imgSrc: "/icons/Event.png",
    type: ArtifactType.event,
    name: ArtifactType.event,
    redirectURL: "../createEvent",
  },
  {
    imgSrc: "/icons/Document.png",
    type: ArtifactType.document,
    name: "Document",
    redirectURL: "../createDocument",
  },
];

const SelectTypes = ({ isOpen, onClose }: PopoverProps) => {
  const navigate = useNavigate();
  const context = useAuth();
  const [title, setTitle] = useState("");
  const [selectedType, setSelectedType] = useState<ArtifactType | null>(null);
  const textCount = 50;
  const inputRef = useRef<HTMLInputElement>(null);

  const [isValidForm, setIsValidForm] = useState(false);

  const schema = Yup.object().shape({
    title: Yup.string().required().max(50),
    selectedType: Yup.string().required(),
  });

  useEffect(() => {
    setTitle("");
    setSelectedType(null);
  }, [isOpen]);

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate({ title, selectedType }, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [title, selectedType, schema]);

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleTypeSelect = (type: ArtifactType) => {
    setSelectedType(type);
    inputRef.current?.focus();
  };

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [isOpen, onClose]);

  const handleCreate = async () => {
    // Handle creation here
    const myChannel = context?.myChannel;
    if (!(myChannel && myChannel.id)) {
      alert("Can not find Channel!");
      return;
    }

    if (selectedType && !isStringEmpty(title)) {
      const artifact: SKArtifactPayload = {
        type: selectedType,
        title,
        subtitle: "",
        tier: Tier.free,
        status: ContentState.DRAFT,
        subStatus: ContentSubstate.NONE,
        autoPublish: true,
        channelId: myChannel.id,
        channelStatus: myChannel.status,
        channelName: myChannel.name,
        channelImage: myChannel.profileImageUrl,
        language: myChannel.language,
      };
      const id = await createArtifact(artifact);
      navigate(id, {
        state: { type: selectedType, containerId: id },
      });

      onClose();
    } else {
      alert("Select type and ");
    }
  };

  return (
    <div className={`fixed z-50 inset-0 flex items-center justify-center ${isOpen ? "visible" : "hidden"}`}>
      <div className="absolute inset-0 bg-black opacity-25"></div>
      <div className="z-10 bg-white rounded-lg shadow-lg w-[491px] h-[585px] overflow-hidden">
        <div className="flex flex-col m-[30px]">
          <p className="content_title">Choose Content Type</p>
          <div className="overflow-y-auto bg-white pt-[15px]">
            <div className="flex flex-wrap justify-center gap-[14px] content-center items-center">
              {types.map((data, index) => (
                <div
                  onClick={() => {
                    handleTypeSelect(data.type);
                  }}
                  key={index}
                  className={
                    (selectedType === data.type ? " border-black border-2 " : "  border-skgray border-[1px] ") +
                    "flex flex-col text-center justify-center first-letter w-[75px] h-[75px] items-center rounded-lg p-[5px] mx-auto"
                  }
                >
                  <img src={data.imgSrc} alt={data.type} className="h-[35px] mini-w-[35px]" />
                  <span className="text-[12px] mt-[1px]">{capitalizeFirstLetter(data.name)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex flex-col mx-[30px] mb-[30px]">
          <h3 className="content_title mb-[15px]">Add Content Title</h3>
          <div className="flex input-class-for-type">
            <input type="text" ref={inputRef} value={title} onChange={handleTitleChange} placeholder="Title" className="input-text-for-type" />
          </div>
          <p className="remaining-characters">{textCount - (title?.length ?? 0)} Characters Remaining.</p>
        </div>
        <div className="thickseparator" />
        <div className="flex flex-col p-[30px]">
          <div className="flex items-center justify-between">
            <button
              className="p-2 px-4 w-[113px] h-[46px] text-lg font-normal text-black border-[1px] border-gray-400 border-solid rounded-lg focus:outline-none"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 ml-4  w-[113px] h-[46px] text-lg font-normal text-white bg-black rounded-lg  hover:bg-gray-700 focus:outline-none disabled:bg-bordergray"
              onClick={handleCreate}
              disabled={!isValidForm}
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTypes;
